import { render, staticRenderFns } from "./PrintableCertificate.vue?vue&type=template&id=1cc77417&scoped=true"
import script from "./PrintableCertificate.vue?vue&type=script&lang=js"
export * from "./PrintableCertificate.vue?vue&type=script&lang=js"
import style0 from "./PrintableCertificate.vue?vue&type=style&index=0&id=1cc77417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc77417",
  null
  
)

export default component.exports